import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  redirectUrl = null;
  hideSplitPane = false;
  constructor() { }
  canShowSplit() {
    return !this.hideSplitPane;
  }
}
